import _styled from "styled-components";
import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as BackIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/back.svg";
import { ReactComponent as BroskIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/brosk.svg";
import { ClickableBroskIcon } from "./ClickableBroskIcon";

var Container = _styled.div.withConfig({
  displayName: "Header__Container",
  componentId: "sc-13rk4m6-0"
})(["display:flex;align-items:center;margin-top:25px;height:40px;padding:0 20px;flex:0 0 auto;"]);

var BackContainer = _styled.div.withConfig({
  displayName: "Header__BackContainer",
  componentId: "sc-13rk4m6-1"
})(["flex:1 1 50%;display:flex;justify-content:flex-start;align-items:center;"]);

var StyledLink = _styled(Link).withConfig({
  displayName: "Header__StyledLink",
  componentId: "sc-13rk4m6-2"
})(["display:flex;justify-content:center;-webkit-tap-highlight-color:rgba(255,255,255,0);&,&:hover,&:active{color:black;text-decoration:none;}"]);

var StyledButton = _styled.button.withConfig({
  displayName: "Header__StyledButton",
  componentId: "sc-13rk4m6-3"
})(["background-color:transparent;border:0 none;padding:0;-webkit-tap-highlight-color:rgba(255,255,255,0);&:focus{outline:0 none;}svg{display:block;}"]);

var BroskIconContainer = _styled.div.withConfig({
  displayName: "Header__BroskIconContainer",
  componentId: "sc-13rk4m6-4"
})(["flex:0 0 auto;display:flex;justify-content:center;align-items:center;svg{width:150px;height:30px;}"]);

var ActionIconContainer = _styled.div.withConfig({
  displayName: "Header__ActionIconContainer",
  componentId: "sc-13rk4m6-5"
})(["flex:1 1 50%;display:flex;justify-content:flex-end;align-items:center;"]);

var ActionButton = _styled.button.withConfig({
  displayName: "Header__ActionButton",
  componentId: "sc-13rk4m6-6"
})(["display:flex;background-color:white;pointer-events:auto;border:none;outline:none;"]);

var sizeBackIcon = 32;
export function Header(_ref) {
  var backTo = _ref.backTo,
      onBack = _ref.onBack,
      ActionIcon = _ref.actionIcon,
      onAction = _ref.onAction,
      _ref$clickable = _ref.clickable,
      clickable = _ref$clickable === void 0 ? false : _ref$clickable;
  var Logo = clickable ? ClickableBroskIcon : BroskIcon;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(BackContainer, null, backTo && /*#__PURE__*/React.createElement(StyledLink, {
    to: backTo
  }, /*#__PURE__*/React.createElement(BackIcon, {
    width: sizeBackIcon,
    height: sizeBackIcon
  })), onBack && /*#__PURE__*/React.createElement(StyledButton, {
    onClick: onBack
  }, /*#__PURE__*/React.createElement(BackIcon, {
    width: sizeBackIcon,
    height: sizeBackIcon
  }))), /*#__PURE__*/React.createElement(BroskIconContainer, null, /*#__PURE__*/React.createElement(Logo, null)), /*#__PURE__*/React.createElement(ActionIconContainer, null, ActionIcon && /*#__PURE__*/React.createElement(ActionButton, {
    onClick: onAction
  }, /*#__PURE__*/React.createElement(ActionIcon, {
    width: 38,
    height: 38
  }))));
}